<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Nova Lista de Preços de Serviços
        </span>
      </h3>
    </div>
    <Form url="/servicos/lista-preco/create" />
  </div>
</template>

<script>
import Form from "./Form.vue";

export default {
  name: "app-lista-preco-servico-create",
  components: {
    Form,
  },
};
</script>
